import { render, staticRenderFns } from "./closemodal.vue?vue&type=template&id=5e8d5b65&scoped=true"
import script from "./closemodal.vue?vue&type=script&lang=js"
export * from "./closemodal.vue?vue&type=script&lang=js"
import style0 from "./closemodal.vue?vue&type=style&index=0&id=5e8d5b65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8d5b65",
  null
  
)

export default component.exports